import React, { useState, useEffect } from "react";
import {
  Elements,
  useStripe,
  useElements,
  PaymentElement,
  AddressElement,
  LinkAuthenticationElement
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  createStripeCheckoutSession,
  createStripePaymentEntent,
  stripe_payment_return_url,
  prestashop_payment_return_url,
  createStripeCustomer,
  synibox_dashboard_url,
  getStripeSubscription,
  createStripeSubscripion as createStripeSubscription,
  applyStripeDiscountCode,
  retrieveStripeUpComingInvoice,
  getStripeProduct,
  SMARTAS,
  createStripeSetupIntent,
  updateStripeCustomer,
  createOnShotPreview,
  finalizePayment,
  createLog,
  klaviyoUpdateProfile
} from "../../helpers/api_helper";
import logo_maaia from "../../assets/images/icons-infos-purple.png";
import {
  Col,
  CardBody,
  Row,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Toast,
  ToastHeader,
  ToastBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
  Modal,
  InputGroup,
  InputGroupText,
  Input,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  UncontrolledTooltip,
  Alert
} from "reactstrap";
import "./PaymentForm.scss";
import InfoMono from "../../assets/images/icons/InfoMono";
import PlusOutlined from "../../assets/images/icons/PlusOutlined";
import ArrowLeftOutlined from "../../assets/images/icons/ArrowLeftOutlined";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Client, Account, Databases, ID, Query } from "appwrite";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import { useSelector } from "react-redux";
import { useMixpanel } from "../../Hooks/useMixpanel";

const PaymentForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState(null);
  const [country, setCountry] = useState(null);

  let navigate = useNavigate();
  const [decompte, setDecompte] = useState(15);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (decompte === 0) {
      navigate(`/settings`, {
        replace: true,
        state: { tab: "billing", modal: "" }
      });
    }
  }, [decompte]);

  useEffect(() => {
    if (redirect) {
      let interval;
      interval = setInterval(() => {
        setDecompte((prevDecompte) => prevDecompte - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [redirect]);

  const { mixPanelTrack } = useMixpanel();

  async function updateClientInfos(data) {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      props.company_id,
      JSON.stringify(data)
    );

    return promise.then(
      async function (response) {
        console.log("updateCompanyInfos success", response); // Success
        return response;
      },
      function (error) {
        console.log("updateCompanyInfos error", error); // Failure
        return null;
      }
    );
  }

  const handleError = (error) => {
    setIsLoading(false);
    setErrorMessage(error.message);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    await updateClientInfos({ stripe_region: country });

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error: submitError } = await elements.submit();
    if (submitError) {
      handleError(submitError);
      return;
    }

    // Confirmer le paiement en utilisant stripe.confirmPayment
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: stripe_payment_return_url // URL de redirection après succès
      },
      redirect: "if_required"
    });

    if (error) {
      // Gérer les erreurs de paiement
      handleError(error);
    } else {
      // Paiement réussi
      console.log("Payment confirmed:", paymentIntent);

      // Finaliser avec la capture du paiement si nécessaire (si capture_method est 'manual')
      if (paymentIntent.capture_method === "manual") {
        const res = await finalizePayment(props.region, paymentIntent.id);

        if (!res) {
          setErrorMessage("system_error");
          setIsLoading(false);
          return;
        } else {
          const company_id = localStorage.getItem("companyId");
          var user_id = JSON.parse(localStorage.getItem("authUser")).userId;

          const updates = {
            properties: {
              stripe_region: country
            }
          };
          klaviyoUpdateProfile(company_id, updates);

          let logData = {
            eventCreatedAt: Date.now(),
            author_id: user_id,
            company_id: company_id,
            number_of_credit: props.credits_pack * 1000
          };
          let logdata = {
            event: "direct_credit_added",
            author_id: user_id,
            company_id: company_id,
            log_data: JSON.stringify(logData)
          };
          createLog(logdata, mixPanelTrack);

          // window.location.href = stripe_payment_return_url;
          setRedirect(true);
        }
      }

      // Exécuter vos actions de succès ici (ex: mise à jour de l'interface utilisateur)
      console.log("Payment finalized successfully");
    }

    setIsLoading(false);
  };

  console.log({ the_passed_region: props.region });

  const defaultAdd =
    props.region === "US"
      ? { name: props.customer_fullName, address: { country: "US" } }
      : {
          name: props.customer_fullName,
          address: { country: props.region || "FR" }
        };

  const handleAddressChange = (event) => {
    let the_country;
    console.log("Address changed:", event);
    if (event.elementType === "address" && event.elementMode === "billing") {
      the_country = event.value.address.country;
      const fullName = event.value.name;
      console.log("Address changed: country is", the_country);
      console.log("Name is", event.value.name);
      props.setCustomerFullName(fullName);
    }

    if (
      (the_country && the_country === "US" && props.region !== "US") ||
      (props.region === "US" && the_country && the_country !== "US")
    ) {
      console.log("Need refresh");
      props.refreshStripePaymentIntent(the_country);
    } else {
      console.log("No need refresh", the_country);
    }
    setCountry(the_country);
  };

  useEffect(() => {
    const company_id = localStorage.getItem("companyId");
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    if (!company_id && !user_id) {
      window.location.href = stripe_payment_return_url;
    }
  }, []);

  return (
    <form
      onSubmit={handleSubmit}
      className="payment-form d-flex"
      style={{ height: "100%" }}
    >
      <div className="my-auto w-100 py-4">
        {errorMessage &&
          errorMessage !== props.t("Ce champ est incomplet.") &&
          !redirect && (
            <Alert color="danger" className="font-primary font-size-12 mb-3">
              {props.t(errorMessage)}
            </Alert>
          )}
        {redirect && (
          <Alert className="text-center" color="success">
            {`${props.t("Opération réussie !")} ${props.t(
              "Vous serez redirigé dans"
            )} ${decompte}sec...`}
          </Alert>
        )}
        <div className="form-group">
          <AddressElement
            options={{
              mode: "billing",
              defaultValues: defaultAdd
            }}
            onChange={handleAddressChange}
          />
        </div>

        <div className="form-group">
          <PaymentElement
            options={{
              layout: {
                type: "accordion",
                defaultCollapsed: false,
                radios: false,
                spacedAccordionItems: false
              }
            }}
          />
        </div>

        <button
          type="submit"
          disabled={isLoading || !stripe || !elements || props.isRefreshing}
          className="r_button"
          id="submit"
        >
          <span id="button-text">
            {isLoading || props.isRefreshing ? (
              <span
                className="spinner-border spinner-border-sm me-2 font-primary"
                role="status"
                aria-hidden="true"
              />
            ) : (
              props.t("Pay now")
            )}
          </span>
        </button>
      </div>
      {message && (
        <div id="payment-message" style={{ margin: "10px 0" }}>
          {message}
        </div>
      )}
    </form>
  );
};

const StripeOneShotCheckout = (props) => {
  // const [stripePromise, setLoadStripe] = useState(undefined);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const [clientSecret, setClientSecret] = useState(null);
  const [paymentIntent, setpaymentIntent] = useState(null);
  const [stripeCustomerID, setStripeCustomerID] = useState(undefined);
  const [customer_email, setCustomerEmail] = useState(null);
  const [customer_fullName, setCustomerFullName] = useState(null);
  const [customerIsLoading, setCustomerIsLoading] = useState(null);
  const [client_data, setCompanyInfos] = useState(undefined);

  const [couponCode, setCouponCode] = useState("");
  const [coupon, setCoupon] = useState(undefined);
  const [couponRequestMessage, setCouponRequestMessage] = useState("");
  const [couponRequestLoading, setCouponRequestLoading] = useState(false);

  const [showUpdateUI, setShowUpdateUI] = useState(false);

  const handlePromoCodeSubmit = async (e) => {
    e.preventDefault();
    setCouponRequestLoading(true);

    try {
      const response = await applyStripeDiscountCode(region, couponCode);

      if (response.valid) {
        setCoupon(response);
        setCouponRequestMessage(
          `${props.t("Code promo appliqué ! Réduction")} : ${
            response.percent_off ? response.percent_off : response.amount_off
          }${response.percent_off ? "%" : "€"}`
        );
        fetchClientSecret(
          region,
          pack_price_id,
          credits_pack,
          stripeCustomerID,
          client_data.$id
        );
      } else {
        setCouponRequestMessage(props.t("Code promo invalide"));
      }
    } catch (error) {
      setCouponRequestMessage(
        props.t("Erreur lors de la validation du code promo")
      );
    }

    setCouponRequestLoading(false);
  };
  const navigate = useNavigate();
  const { search } = useLocation();

  const urlParams = new URLSearchParams(search);
  let region = urlParams.get("region") || undefined;
  const credits_pack = urlParams.get("c") ?? 1;
  const user_plan = urlParams.get("p");

  let stripePromise;
  let pack_price_id;
  if (region && region === "US") {
    console.log("Load strip for US");

    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_USA);
    pack_price_id = SMARTAS.CREDITS.US[user_plan];
  } else {
    console.log("Load strip for World");
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_WORLD);
    pack_price_id = SMARTAS.CREDITS.WOLRD[user_plan];
  }

  const handleEmailChange = (email) => {
    console.log("Email changed: email is", email);
    setCustomerEmail(email);
  };

  const refreshStripePaymentIntent = async (region) => {
    console.log("start refreshStripePaymentIntent");

    if (region === "US") {
      window.location.href = `${synibox_dashboard_url}/one-shot-checkout?region=US&c=${credits_pack}&p=${user_plan}`;
    } else {
      window.location.href = `${synibox_dashboard_url}/one-shot-checkout?c=${credits_pack}&p=${user_plan}`;
    }
  };

  const handleCreateCustomer = async (email, name) => {
    setCustomerIsLoading(true);
    console.log("Started creating customer");

    let customer_data;
    if (region && region === "US") {
      customer_data = await createStripeCustomer("US", email, name);
      console.log({ customer_data });
    } else {
      customer_data = await createStripeCustomer(undefined, email, name);
      console.log({ customer_data });
    }
    setCustomerIsLoading(false);

    if (customer_data) {
      setStripeCustomerID(customer_data.customer.id);
      fetchClientSecret(
        region,
        pack_price_id,
        credits_pack,
        customer_data.customer.id,
        client_data.$id
      );
    }
  };

  const fetchClientSecret = async (
    region,
    pack_price_id,
    credits_pack,
    the_stripe_customer_id,
    company_id
  ) => {
    setPageLoading(true);

    const response = await createOnShotPreview(
      region,
      pack_price_id,
      credits_pack,
      the_stripe_customer_id,
      company_id
    );

    setPageLoading(false);

    if (response) {
      const paymentIntent = response.paymentIntent;
      setpaymentIntent(paymentIntent);
      setClientSecret(paymentIntent.client_secret);
    } else {
      navigate(`/settings`, {
        replace: true,
        state: { tab: "billing", modal: "" }
      });
    }
  };

  useEffect(() => {
    initCustomer();
  }, []);

  const initCustomer = async () => {
    setPageLoading(true);
    setCustomerIsLoading(true);
    const user_string = localStorage.getItem("user");
    const user = user_string ? JSON.parse(user_string) : undefined;

    if (
      user_string &&
      user &&
      user.prefs &&
      user.prefs["owner"] &&
      (user.prefs["owner"] === "true" || user.prefs["owner"] === true)
    ) {
      const the_client_data = await getClientData();

      if (!the_client_data) {
        console.log("No company infos");

        return;
      }
      setCompanyInfos(the_client_data);

      console.log({ synibox_user_name: user });
      handleEmailChange(user.email);
      setCustomerFullName(
        [user.prefs["first_name"], user.prefs["last_name"]]
          .filter(Boolean)
          .join(" ")
      );
      const stripe_customer_id = the_client_data.stripe_customer_id;
      if (stripe_customer_id) {
        setStripeCustomerID(stripe_customer_id);

        const response = await createOnShotPreview(
          region,
          pack_price_id,
          credits_pack,
          stripe_customer_id,
          the_client_data.$id
        );

        if (response) {
          console.log({ createOnShotPreview: response });

          const paymentIntent = response.paymentIntent;
          if (paymentIntent) {
            setpaymentIntent(paymentIntent);
            setClientSecret(paymentIntent.client_secret);
          }
        } else {
          navigate(`/settings`, {
            replace: true,
            state: { tab: "billing", modal: "" }
          });
        }
      }
    }
    setCustomerIsLoading(false);
    setPageLoading(false);
  };

  const onCompanyInfoChanged = (val) => {
    setCompanyInfos(val);
  };

  const getClientData = async function () {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      const response = await databases.getDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId")
      );
      console.log("getClientData", response);
      onCompanyInfoChanged(response);
      return response;
    } catch (error) {
      console.log(error); // Failure
      return null;
    }
  };

  const options = {
    paymentMethodOrder: ["apple_pay", "google_pay", "card", "klarna"],
    appearance: {
      theme: "stripe"
    },
    clientSecret,
    layout: {
      type: "accordion",
      defaultCollapsed: false
    },
    locale: props.i18n.language
  };

  return (
    <div
      className="d-flex align-items-center"
      style={{
        height: "100vh",
        backgroundColor: "white"
      }}
    >
      <>
        <Col
          className=""
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            paddingRight: "70px",
            overflow: "auto"
          }}
        >
          <div
            className="d-flex ms-auto"
            style={{ flexDirection: "column", width: "500px", height: "100%" }}
          >
            <div className="my-auto">
              <div className={`d-flex align-items-center gap-1 mb-3`}>
                <img src={logo_maaia} alt="logo_maaia" height={30} />
                <p
                  className="font-size-16 mb-0 ms-1"
                  style={{ fontWeight: "500" }}
                >
                  Synibox
                </p>
              </div>

              <div className="d-flex mb-3" style={{ flexDirection: "column" }}>
                <p className="font-size-16 mb-0" style={{ fontWeight: "500" }}>
                  Synibox
                </p>
                {paymentIntent && (
                  <>
                    {paymentIntent && (
                      <div className={"addon_card"}>
                        <div className="my-2 w-100">
                          <div className="d-flex">
                            <div
                              className="d-flex w-100"
                              style={{
                                flexDirection: "column"
                              }}
                            >
                              <div className="d-flex justify-content-between w-100">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column"
                                  }}
                                >
                                  <div className="product_name">
                                    {paymentIntent.description
                                      .split(" ")
                                      .map((word) => props.t(word))
                                      .join(" ")}
                                  </div>
                                </div>
                                <span
                                  className="line_item_price"
                                  style={{ fontWeight: "600" }}
                                >
                                  {paymentIntent.currency === "usd" ? "$" : "€"}
                                  {paymentIntent.amount / 100}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div>
                      <div className="mt-3">
                        {paymentIntent && (
                          <div
                            className="d-flex align-items-center justify-content-between pb-3"
                            style={{
                              borderBottom: "1px solid rgba(15, 15, 15, 0.1)"
                            }}
                          >
                            <div className="product_name">
                              {props.t("Subtotal")}
                            </div>
                            <span className="line_item_price">
                              {" "}
                              {paymentIntent.currency === "usd" ? "$" : "€"}
                              {paymentIntent.amount / 100}
                            </span>
                          </div>
                        )}
                      </div>

                      {/* {paymentIntent && (
                    <div>
                      <div>
                        <input
                          className="w-100"
                          type="text"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                          placeholder="Code promo"
                        />
                        <button className="l_button py-2 px-3 mt-2" onClick={handlePromoCodeSubmit} disabled={couponRequestLoading || coupon}>
                          {couponRequestLoading && (
                            <span className="spinner-border spinner-border-sm me-2 font-primary" role="status" aria-hidden="true" />
                          )}
                          {props.t(coupon ? "Appliqué" : "Appliquer le code")}
                        </button>
                      </div>

                      {couponRequestMessage && <div className="font-size-12">{couponRequestMessage}</div>}
                    </div>
                  )} */}

                      {paymentIntent && (
                        <div className="mt-3">
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ fontWeight: "600" }}
                          >
                            <div className="product_name">
                              {props.t("Total to pay today")}
                            </div>
                            <span className="line_item_price">
                              {paymentIntent.currency === "usd" ? "$" : "€"}
                              {paymentIntent.amount / 100}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div style={{ alignSelf: "end" }}>
            <LanguageDropdown hasArrow />
          </div>
        </Col>
        <Col
          className=""
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            boxShadow: "-12px 0px 15px -4px rgba(128, 128, 128, 0.15)",
            paddingLeft: "70px",
            overflow: "auto"
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center"
            }}
          >
            {!stripeCustomerID && !pageLoading && (
              <div className="form-group">
                <label htmlFor="email">{props.t("E-mail")}</label>
                <input
                  className="w-100"
                  id="email"
                  type="email"
                  value={customer_email}
                  onChange={(e) => handleEmailChange(e.target.value)}
                  placeholder={props.t("Enter your e-mail address")}
                />
                <button
                  type="submit"
                  disabled={!customer_email}
                  className="r_button mt-3"
                  onClick={(e) =>
                    handleCreateCustomer(customer_email, customer_fullName)
                  }
                >
                  <span id="button-text">
                    {customerIsLoading || props.isRefreshing ? (
                      <span
                        className="spinner-border spinner-border-sm me-2 font-primary"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      props.t("Continuer")
                    )}
                  </span>
                </button>
              </div>
            )}

            {pageLoading ? (
              <div
                className="mt-4 font-size-16 gap-1"
                style={{
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <span
                  className="spinner-border spinner-border-md me-2 font-primary text-center"
                  role="status"
                  aria-hidden="true"
                />
                {props.t("Chargement") + "..."}
              </div>
            ) : (
              clientSecret && (
                <Elements stripe={stripePromise} options={options}>
                  <PaymentForm
                    refreshStripePaymentIntent={refreshStripePaymentIntent}
                    isRefreshing={isRefreshing}
                    stripeCustomerID={stripeCustomerID}
                    region={
                      client_data && client_data.stripe_region
                        ? client_data.stripe_region
                        : region
                    }
                    credits_pack={credits_pack}
                    setCustomerFullName={setCustomerFullName}
                    customer_email={customer_email}
                    customer_fullName={customer_fullName}
                    company_id={client_data ? client_data.$id : undefined}
                    pack_price_id={pack_price_id}
                    t={props.t}
                  />
                </Elements>
              )
            )}
          </div>
        </Col>
      </>
    </div>
  );

  function ProductCard(
    plan,
    is_plan,
    trial = false,
    description = null,
    region = undefined
  ) {
    return (
      <div className={is_plan ? "addon_card" : ""}>
        <div className="my-2 w-100">
          <div className="d-flex">
            <div
              className="d-flex w-100"
              style={{
                flexDirection: "column"
              }}
            >
              <div className="d-flex justify-content-between w-100">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <div className="product_name">
                    {description
                      ? props.t("Trial period for ") + description
                      : plan.description
                          .split(" ")
                          .map((word) => props.t(word))
                          .join(" ")}
                  </div>
                  {!trial && (
                    <div>
                      <select className="qty_select">
                        {plan.plan.interval === "month" ? (
                          <option value="Monthly">{props.t("Monthly")}</option>
                        ) : (
                          <option value="Yearly">{props.t("Yearly")}</option>
                        )}
                      </select>
                    </div>
                  )}
                </div>
                <span className="line_item_price" style={{ fontWeight: "600" }}>
                  {trial
                    ? region === "US"
                      ? "$"
                      : "€"
                    : plan.plan.currency === "usd"
                    ? "$"
                    : "€"}
                  {trial ? "00.00" : plan.amount / 100}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default withTranslation()(StripeOneShotCheckout);
